import './search.css';

var styles = {"searchWrapper":"searchWrapper__2SbA1","inputWrapper":"inputWrapper__2ts-S","search":"search__2Obok","searchButton":"searchButton__WsWor","clear":"clear__3nt4n","cancel":"cancel__3haia","searchWrapperCategory":"searchWrapperCategory__2Dik1"};

export { styles as default };
